import { render, staticRenderFns } from "./categoriaEspecifica.vue?vue&type=template&id=400415c3&scoped=true&"
import script from "./categoriaEspecifica.vue?vue&type=script&lang=js&"
export * from "./categoriaEspecifica.vue?vue&type=script&lang=js&"
import style0 from "./categoriaEspecifica.vue?vue&type=style&index=0&id=400415c3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "400415c3",
  null
  
)

export default component.exports